import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../header/header";
import { useGame } from "../header/GameContext";
import { CHAT_DATA } from "./chatData";
import "./chat.css";

function ChatBox({ onFinish, defaultPath, timerMode }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { startTimer, pauseTimer, openHint, isFinalQuiz, TOTAL_GAME_TIME } =
    useGame();

  const state = location.state || {};
  const { DateVal, titImgClass } = state;

  /* =========================
     타이머
  ========================= */
  useEffect(() => {
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode]);

  /* =========================
     게임시간(분) — {{totalGameTime}} 치환용
     ADMIN_TIME_KEY = 관리자 설정 원래값
  ========================= */
  const totalGameMin = Math.floor(
    (Number(localStorage.getItem("ADMIN_TIME_KEY")) ||
      Number(TOTAL_GAME_TIME) ||
      0) / 60,
  );

  /* =========================
     데이터 + 치환
  ========================= */
  let rawContents = [];
  if (DateVal === "DATA1") rawContents = CHAT_DATA.dataArr01;
  else if (DateVal === "DATA2") rawContents = CHAT_DATA.dataArr02;
  else rawContents = CHAT_DATA[DateVal] || [];

  // {{totalGameTime}} → 실제 분 치환
  const contents = rawContents.map((item) => ({
    ...item,
    text: item.text?.replace(/\{\{totalGameTime\}\}/g, String(totalGameMin)),
  }));

  /* =========================
     상태
  ========================= */
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState([]);
  const [activeButton, setActiveButton] = useState(null);

  const chatBoxRef = useRef(null);

  /* =========================
     스크롤
  ========================= */
  const scrollToBottom = () => {
    if (!chatBoxRef.current) return;
    chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
  };

  const scrollWithOffset = () => {
    if (!chatBoxRef.current) return;
    const box = chatBoxRef.current;
    const OFFSET = 80;
    box.scrollTop = box.scrollHeight - box.clientHeight + OFFSET;
  };

  /* =========================
     채팅 출력 로직
  ========================= */
  useEffect(() => {
    if (idx >= contents.length) return;

    const item = contents[idx];

    if (item.type === "scroll") {
      setIdx((prev) => prev + 1);
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 0);
      return;
    }

    if (item.type === "button") {
      setActiveButton(item);
      requestAnimationFrame(() => {
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: "smooth",
        });
      });
      return;
    }

    const t = setTimeout(() => {
      setVisible((prev) => [...prev, item]);
      setIdx((prev) => prev + 1);
    }, 1000);

    return () => clearTimeout(t);
  }, [idx]);

  useEffect(() => {
    requestAnimationFrame(scrollWithOffset);
  }, [visible]);

  /* =========================
     버튼 클릭
  ========================= */
  const onBtnClick = () => {
    if (!activeButton) return;
    const { action, route, state } = activeButton;
    setActiveButton(null);
    setIdx((prev) => prev + 1);
    const actionMap = {
      finish: () => onFinish?.({ route, defaultPath, state }),
      route: () => onFinish?.({ route, defaultPath, state }),
    };
    actionMap[action]?.();
  };

  return (
    <div className="box content_box1">
      <Header isFinalQuiz={isFinalQuiz(DateVal)} />

      <div className="box_con con_box1 con_pd5 ans0001">
        <div className={`mission_tit ${titImgClass}`} />

        <div
          className="chat_box2 mt24"
          ref={chatBoxRef}
          style={{ overflowY: "auto", maxHeight: "400px" }}
        >
          {visible.map((c, i) => {
            if (c.type === "chatInfo_Talk1") {
              return (
                <div
                  key={i}
                  className={`chatInfo_Talk ${c.marType || ""}`}
                  dangerouslySetInnerHTML={{ __html: c.text }}
                />
              );
            }
            if (c.type === "leftCharacter") {
              return (
                <div key={i} className={`chat_b_left ${c.marType || ""}`}>
                  <div className="chat_b_l_left mr8">
                    <span className={c.chat_icon} />
                  </div>
                  <div className="chat_b_l_right">
                    <p className="chat_tit mb4">{c.chat_tit}</p>
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }
            if (c.type === "left_txt") {
              return (
                <div key={i} className={`chat_b_left ${c.marType || ""}`}>
                  <div className="chat_b_l_left mr8" />
                  <div className="chat_b_l_right">
                    <div
                      className={c.talkType}
                      dangerouslySetInnerHTML={{ __html: c.text }}
                    />
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>

        {activeButton && (
          <div className="chat_btn_area mt20">
            <button className="inputBtn02" onClick={onBtnClick}>
              {activeButton.label}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatBox;
